import React from 'react';
import { Link } from 'react-router-dom';

const pageLinks = [
    { to: '/', label: 'Hjem' },
    { to: '/cycles', label: 'Cykler' },
    { to: '/accessories', label: 'Tilbehør' },
    { to: '/repairs', label: 'Værksted' },
    { to: '/rent-a-cycle', label: 'Cykeludlejning' },
];

const infoLinks = [
    { to: '/about', label: 'Om Os' },
    { to: '/contact', label: 'Kontakt' },
    { to: '/shipping-and-returns', label: 'Levering & Returnering' },
    { to: '/privacy-policy', label: 'Privatlivspolitik' },
    { to: '/terms-and-conditions', label: 'Handelsbetingelser' },
];

class Footer extends React.Component {

    render(){
        const year = new Date().getFullYear();

        return (
            <footer className="main-footer">
                <div className="container">
                    <div className="row footer-top">

                        <div className="col-xs-12 col-sm-6 col-md-4 footer-col">
                            <Link to="/" className="footer-logo">
                                <img src="/images/logo-lg.png" alt="Alaska Cykler" />
                            </Link>
                            <p className="footer-about">
                                Kvalitetscykler, tilbehør og professionelt værksted i Brønshøj – med mere end 15 års erfaring.
                            </p>
                            <ul className="footer-social">
                                <li>
                                    <a href="https://www.facebook.com/friesercykler/" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
                                        <img src="/images/social/facebook.svg" alt="Facebook" />
                                    </a>
                                </li>
                                <li>
                                    <a href="https://www.instagram.com/alaska_cykler/" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
                                        <img src="/images/social/instagram.svg" alt="Instagram" />
                                    </a>
                                </li>
                            </ul>
                        </div>

                        <div className="col-xs-6 col-sm-3 col-md-2 footer-col">
                            <h4 className="footer-title">Sider</h4>
                            <ul className="footer-links">
                                {pageLinks.map(link => (
                                    <li key={link.to}><Link to={link.to}>{link.label}</Link></li>
                                ))}
                            </ul>
                        </div>

                        <div className="col-xs-6 col-sm-3 col-md-2 footer-col">
                            <h4 className="footer-title">Information</h4>
                            <ul className="footer-links">
                                {infoLinks.map(link => (
                                    <li key={link.to}><Link to={link.to}>{link.label}</Link></li>
                                ))}
                            </ul>
                        </div>

                        <div className="clearfix visible-sm"></div>

                        <div className="col-xs-12 col-sm-12 col-md-4 footer-col">
                            <h4 className="footer-title">Kontakt &amp; Åbningstider</h4>
                            <ul className="footer-contact">
                                <li>
                                    <span className="pe-7s-map-marker"></span>
                                    Islevhusvej 7, 2700 Brønshøj
                                </li>
                                <li>
                                    <span className="pe-7s-call"></span>
                                    <a href="tel:+4571873167">+45 71 87 31 67</a>
                                </li>
                                <li>
                                    <span className="pe-7s-mail"></span>
                                    <a href="mailto:alaskacykler@mail.com">alaskacykler@mail.com</a>
                                </li>
                                <li>
                                    <span className="pe-7s-clock"></span>
                                    <div>
                                        Mandag – Fredag: kl. 10:00 – 18:00<br />
                                        Lørdag: kl. 10:00 – 16:00<br />
                                        Søndag og helligdage: køb af nye cykler kan aftales
                                    </div>
                                </li>
                            </ul>
                        </div>

                    </div>
                </div>

                <div className="footer-bottom">
                    <div className="container">
                        <p className="footer-copy">
                            © {year} Alaska Cykler · CVR: 38971069
                        </p>
                        <p className="footer-disclaimer">
                            Vi tager forbehold for tastefejl og prisændringer. Har du spørgsmål, er du altid velkommen til at kontakte os.
                        </p>
                    </div>
                </div>
            </footer>
        )
    }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/Common/Footer.js